import React, { useMemo, useState } from 'react';

const TableComponent = ({
    data = [],
    columns = [],
    title,
    showTotal = false,
    totalColumn = null,
    className = '',
    maxHeight = '500px',
    isLastTotal = false,
    formatNumber = (value) => value
}) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredData = useMemo(() => {
        let result = data;
    
        if (searchTerm) {
            result = result.filter((item) =>
                columns.some((column) => {
                    const value = item[column.key];
                    return value
                        ?.toString()
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase());
                })
            );
        }
    
        if (searchTerm && !showTotal && columns.length > 0 && isLastTotal) {
            const firstKey = columns[0].key;
            result = result.filter((item) => item[firstKey]?.toString() !== "Total");
        }
    
        return result;
    }, [data, searchTerm, columns, showTotal, isLastTotal]);

    const calculateTotal = () => {
        if (!showTotal || !totalColumn || !filteredData.length) return 0;

        return filteredData.reduce((acc, item) => {
            const value = Number(item[totalColumn]);
            if (isNaN(value)) {
                return acc;
            }
            return (
                acc +
                (typeof value === 'number' ? value : parseFloat(value) || 0)
            );
        }, 0);
    };

    const total = calculateTotal();

    return (
        <div
            className={`tabela-container-dashboards ${className}`}
            style={{ maxHeight }}
        >
            <div className="table-header">
                {title && <div className="table-title">{title}</div>}
                <input
                    type="text"
                    placeholder="Pesquisar..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="table-search"
                />
            </div>

            <table className="table table-striped-columns">
                <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th key={index} style={column.headerStyle}>
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map((item, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={
                                isLastTotal && rowIndex === filteredData.length - 1
                                    ? 'table-total-row'
                                    : ''
                            }
                        >
                            {columns.map((column, colIndex) => {
                                let cellValue = item[column.key];

                                if (
                                    column.formatter &&
                                    typeof column.formatter === 'function'
                                ) {
                                    cellValue =
                                        column.formatter(cellValue, item) ?? '-';
                                } else if (
                                    column.key === totalColumn &&
                                    formatNumber
                                ) {
                                    cellValue = formatNumber(cellValue) ?? '-';
                                }

                                return (
                                    <td key={colIndex} style={column.cellStyle}>
                                        {cellValue}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}

                    {showTotal && (
                        <tr className="table-total-row">
                            <td>Total</td>
                            {columns.slice(1).map((column, index) => (
                                <td key={index} style={column.cellStyle}>
                                    {column.key === totalColumn
                                        ? formatNumber(total)
                                        : ''}
                                </td>
                            ))}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );

};

export default TableComponent;